import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Brings a section the address names into view, once its list has loaded. */
export function useScrollToHash(id: string, ready: boolean): void {
  const { hash } = useLocation();
  useEffect(() => {
    if (ready && hash === `#${id}`) {
      document.getElementById(id)?.scrollIntoView();
    }
  }, [hash, id, ready]);
}
